import React, { useState, useEffect } from 'react';
import { Col, Row, Input } from 'reactstrap';
import HerosectionHeader from "../../../../Componet/Herosection/HerosectionHeader";
import Options from '../../../../Componet/Option/Options';
import LocationAutocomplete from '../../../../Componet/Autocomplete/LocationAutocomplete';
import { States } from '../../../../store/Utility/Data';
import Modal from 'react-bootstrap/Modal';
import useAxiosPrivate from '../../../../hooks/useAxiosPrivate';
import { useSpinner } from '../../../../context/SpinnerContext';

const initialProfileData = {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    address: '',
    city: '',
    state: '',
    zipCode: '',
    serviceAddress: null,
    serviceLatitude: null,
    serviceLongitude: null,
    taxId: ''
}

const Profile = () => {
    const [profileData, setProfileData] = useState(initialProfileData);
    const [isAddressEdit, setAddressEdit] = useState(false);
    const [modal, showModal] = useState({ show: false, message: null });
    const axiosPrivate = useAxiosPrivate();
    const { showLoader, hideLoader } = useSpinner();

    function updateProfileFields(fields) {
        setProfileData(prev => {
            return { ...prev, ...fields }
        })
    }


    const onPlaceChanged = (place) => {

        const addressComponents = place.address_components;


        var result = {
            city: profileData.city,
            state: profileData.state,
            zipCode: profileData.zipCode,
            address: profileData.address
        };

        const state = addressComponents.find(component => component.types.includes('administrative_area_level_1'));
        if (state != null) {
            result.state = state.short_name;
        }
        const city = addressComponents.find(component => component.types.includes('locality'));
        if (city != null) {
            result.city = city.short_name;
        }
        const postalCode = addressComponents.find(component => component.types.includes('postal_code'));

        if (place.formatted_address) {
            result.address = place.formatted_address;
        }

        if (postalCode) {
            result.zipCode = postalCode.short_name;
        }

        if (place.geometry.location) {
            result.serviceLatitude = place.geometry.location.lat();
            result.serviceLongitude = place.geometry.location.lng();
        }

        if (Object.keys(result).length > 0) {
            updateProfileFields(result);
        }

    }

    const onServiceZipCodePlaceChanged = (place) => {
        if (!place) return;

        var result = {
            serviceAddress: profileData.serviceAddress,
            serviceLatitude: profileData.serviceLatitude,
            serviceLongitude: profileData.serviceLongitude,
            serviceZipCode: profileData.zipCodes
        };

        const addressComponents = place.address_components;

        if (place.formatted_address) {
            result.serviceAddress = place.formatted_address;
        }

        const postalCode = addressComponents.find(component => component.types.includes('postal_code'));

        if (place.geometry.location) {
            result.serviceLatitude = place.geometry.location.lat();
            result.serviceLongitude = place.geometry.location.lng();
        }

        if (postalCode) {
            result.serviceZipCode = postalCode.short_name
            updateProfileFields(result);
        }
    }

    const handleStateChange = (e) => {
        updateProfileFields({ state: e.target.value })
    }
    useEffect(() => {
        getProfile();
    }, [])

    const handleClose = () => showModal({ show: false, message: null });

    const getProfile = async () => {
        showLoader();
        await axiosPrivate.get(`v1/tenant/profile`).then(res => {

            var response = res?.data.data;
            setProfileData(response);
        }).catch(error => {
            if (error.response.data.statusCode = 404) {
                showModal({ show: true, message: "No data found" })
            }
        });
        hideLoader();
    };

    return (
        <div>
            <HerosectionHeader folder1={"pages"} folder2={"Company"} name={"Profile"} />
            {<Modal show={modal.show} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Result</Modal.Title>
                </Modal.Header>
                <Modal.Body>{modal.message}</Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-dark" onClick={handleClose}>Close</button>
                </Modal.Footer>
            </Modal>}
            <section>
                <div className="container">
                    <Row>
                        <Col>
                            <div className="row justify-content-center text-center">
                                <div className="col-lg-10 col-md-12">
                                    <div className="mb-5">
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12 col-md-10 ms-auto me-auto">
                                    <div className="register-form border p-4 rounded">
                                        <form id="contact-form">
                                            <div className="messages"></div>
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label htmlFor="name">Company Name</label>
                                                        <input id="name" type="text" name="name"
                                                            className="form-control"
                                                            minLength={5}
                                                            maxLength={5}
                                                            value={profileData.name}
                                                            onChange={e => updateProfileFields({ name: e.target.value })}
                                                            disabled placeholder="Zip Code" required="required" />
                                                        <div className="help-block with-errors"></div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label htmlFor="email">Company Email</label>
                                                        <input id="email" type="text" name="email"
                                                            className="form-control"
                                                            minLength={5}
                                                            maxLength={5}
                                                            value={profileData.email}
                                                            onChange={e => updateProfileFields({ email: e.target.value })}
                                                            disabled placeholder="Email" required="required" />
                                                        <div className="help-block with-errors"></div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label htmlFor="phone">Company Phone</label>
                                                        <input id="name" type="text" name="phone"
                                                            className="form-control"
                                                            minLength={5}
                                                            maxLength={5}
                                                            value={profileData.phone}
                                                            onChange={e => updateProfileFields({ phone: e.target.value })}
                                                            disabled placeholder="Phone" required="required" />
                                                        <div className="help-block with-errors"></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label htmlFor="contactFullName">Contact Full Name</label>
                                                        <input id="contactFullName" type="text" name="contactFullName"
                                                            className="form-control"
                                                            minLength={5}
                                                            maxLength={5}
                                                            value={profileData.contactFullName}
                                                            onChange={e => updateProfileFields({ contactFullName: e.target.value })}
                                                            disabled placeholder="Contact Full Name" required="required" />
                                                        <div className="help-block with-errors"></div>
                                                    </div>
                                                </div>
                                                <div className="col-md-8">
                                                    <div className="form-group">
                                                        <label htmlFor="address">Address </label>
                                                        <LocationAutocomplete disabled={!isAddressEdit} onPlaceChanged={onPlaceChanged} defaultValue={profileData.address} />
                                                    </div>
                                                </div>

                                            </div>

                                            <div className="row">
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label htmlFor="city">City </label>
                                                        <input id="city" type="text" name="city" className="form-control"
                                                            value={profileData.city}
                                                            onChange={e => updateProfileFields({ city: e.target.value })}
                                                            disabled placeholder="City" required="required" data-error="Valid email is required." />
                                                        <div className="help-block with-errors"></div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label htmlFor="state">State </label>
                                                        <Input
                                                            type="select"
                                                            id="requesterState"
                                                            name="requesterState"
                                                            value={profileData.state}
                                                            className="form-control"
                                                            onChange={handleStateChange}
                                                            disabled
                                                        >
                                                            <Options data={States} />
                                                        </Input>
                                                        <div className="help-block with-errors"></div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label htmlFor="zipCode">Zip Code </label>
                                                        <input id="zipCode" type="text" name="zipCode"
                                                            className="form-control"
                                                            minLength={5}
                                                            maxLength={5}
                                                            value={profileData.zipCode}
                                                            onChange={e => updateProfileFields({ zipCode: e.target.value })}
                                                            disabled placeholder="Zip Code" required="required" data-error="Valid email is required." />
                                                        <div className="help-block with-errors"></div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">

                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label htmlFor="taxId">Tax ID (EIN) </label>
                                                        <input id="taxId" type="text" disabled={!isAddressEdit} name="taxId"
                                                            className="form-control" placeholder="Tax ID (EIN)"
                                                            value={profileData.taxId}
                                                            onChange={e => updateProfileFields({ taxId: e.target.value })} />
                                                    </div>
                                                </div>
                                            </div>


                                            <div className="row">
                                                <div className="col-md-4">
                                                </div>
                                                <div className="col-md-6">
                                                </div>
                                                <div className="col-md-2">

                                                </div>
                                            </div>

                                            <div className="row mt-3"><div className="col-md-12">
                                                <span> If you need to update any of your account information, please contact us and we will be happy to assist you.</span></div></div>
                                        </form>
                                    </div>
                                </div>
                            </div>

                        </Col>
                    </Row>
                </div></section>
        </div>
    )
}

export default Profile;